<template>
  <section v-intersect="onIntersect" :class="{fade: isIntersecting}" class="section owner" id="owner">
    <div class="section-wrapper">
      <h2 :class="{expandTitle: isIntersecting}" class="section-title">OWNER</h2>
      <div class="underline"></div>
      <div class="content-wrapper">
        <div class="content">
          <h3 class="description-title">サロンオーナー</h3>
          <Wrapper>
            <p><v-icon>mdi-paw</v-icon> Sae Machida</p>
          </Wrapper>
          <h4 class="description-title">経歴</h4>
          <Wrapper>
            <p><v-icon>mdi-paw</v-icon> 千葉の専門学校を卒業</p>
            <p><v-icon>mdi-paw</v-icon> 個人営業のドッグサロンで４年</p>
            <p><v-icon>mdi-paw</v-icon> 動物病院のトリマーで２年</p>
            <p><v-icon>mdi-paw</v-icon> 大手チェーン店で５年</p>
            <p><v-icon>mdi-paw</v-icon> 2016年10月 <span class="strong" :class="{strongFont: isIntersecting}">Dog Salon Free</span>をオープン</p>
          </Wrapper>
          <h4 class="description-title">愛犬</h4>
          <Wrapper>
            <p><v-icon>mdi-paw</v-icon> オーナー町田と「じっぽ」と「らいた」</p>
          </Wrapper>
          <img class="owner-image image" src="../../assets/img/owner/owner.jpg" alt="サロンオーナーの画像">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Wrapper from './Wrapper'
export default {
  name: 'owner',
  components: {
    Wrapper,
  },
  data(){
    return {
      isIntersecting: false,
    }
  },
  methods: {
    onIntersect (entries) {
      this.isIntersecting = entries[0].isIntersecting
    },
  },
}
</script>

<style lang="scss">
  .image {
    width: 100%;
    max-width: 400px;
  }
</style>